import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  PDFViewer,
  Image,
} from '@react-pdf/renderer';
import {useLocation} from 'react-router-dom';
import styles from './styles';
import ClientDetailsInfo from './ClientDetailsInfoPDF';
import ElevatorControlList from './ElevatorControlList';
import EscalatorControlList from './EscalatorControlList/EscalatorControlList';
import FooterPDF from './FooterPDF';

import LOGO from '../../../assets/logo.png';

const TYPES = {
  elevator: ElevatorControlList,
  escalator: EscalatorControlList,
};

const PdfViewerScreen = ({templateType}) => {
  const location = useLocation();
  const {
    elevator,
    date,
    ordinalNr,
    client,
    address,
    elevatorId,
    project,
    period,
    type,
    images,
    ...props
  } = location.state;
  // const payload = location.state;

  console.log("📝 Received payload in PDF view:", location.state);

  const Klass = TYPES[templateType] || React.Fragment;

  return (
    <PDFViewer width="100%">
      <Document title={`${elevator} service report`} author="Uplift L.L.C">
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.title}>
              FORMULARI I SERVISIMIT TË RREGULLT TË ASHENSORIT
            </Text>
            <Image src={LOGO} style={styles.logo} />
          </View>
          <Text style={styles.date}>Data: {date}</Text>
          <ClientDetailsInfo
            ordinalNr={ordinalNr}
            client={client}
            elevator={elevator}
            address={address}
            elevatorId={elevatorId}
            project={project}
            period={period}
            type={type}
          />
          <Klass {...props} />
          <FooterPDF />
        </Page>
        <Page size="A4" style={styles.page}>
        <View style={[styles.header, {marginBottom: 50}]}>
            <Text style={styles.title}>
            SEKSION FOTOGRAFIK
            </Text>
            <Image src={LOGO} style={styles.logo} />
          </View>
          <View style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap', 
            justifyContent: 'space-between', 
            gap: '10px', 
          }}>
            {images &&
              images.map((image, index) => (
                <Image
                  key={index}
                  src={image}
                  style={{
                    width: '30%', 
                    height: 'auto', 
                    objectFit: 'cover', 
                    borderRadius: '5px', 
                  }}
                />
              ))}
          </View>
          <FooterPDF />
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default PdfViewerScreen;
